import React from 'react';
const stats = [{
  value: '+2.400',
  label: 'madres confían'
}, {
  value: '6+6',
  label: 'Tomos + Bonos'
}, {
  value: '4.9/5',
  label: 'calificación ⭐'
}, {
  value: '🇦🇷',
  label: 'Todo el país'
}];
const testimonials = [{
  initials: 'LP',
  quote: '"Pensé que estimular bien requería ser especialista. Con el Megapack entendí todo, sé exactamente qué hacer cada semana y veo los resultados en mi hijo."',
  author: '— Laura P., Buenos Aires | Mamá de Mateo, 8 meses'
}, {
  initials: 'MC',
  quote: '"El semáforo de alertas me salvó. Detecté a tiempo que mi nena no estaba desarrollando el lenguaje como debía y pudimos actuar antes de que fuera tarde."',
  author: '— Marcela C., Rosario | Mamá de Valentina, 18 meses'
}, {
  initials: 'SV',
  quote: '"Antes improvisaba todo y me sentía culpable por no saber si lo estaba haciendo bien. Ahora tengo un sistema, tengo confianza y mi hijo lo nota."',
  author: '— Sofía V., Córdoba | Mamá de Benjamín, 14 meses'
}];
export function SocialProof() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-8 text-gray-900 text-base leading-6" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(253,244,255) 0%, rgb(243,232,255) 15%, rgb(243,232,255) 85%, rgb(252,248,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-285">
      <div className="mx-auto max-w-4xl" data-id="element-286">

        {/* ── STATS GRID ── */}
        <div className="mb-8 grid grid-cols-2 md:grid-cols-4 gap-3 text-center" data-id="element-287">
          {stats.map(stat => <div key={stat.label} data-id="element-288">
              <div className="text-2xl sm:text-4xl leading-[32px] sm:leading-[40px] font-black text-gray-900" data-id="element-289">
                {stat.value}
              </div>
              <div className="mt-1 text-[10px] sm:text-xs font-semibold text-purple-700" data-id="element-290">
                {stat.label}
              </div>
            </div>)}
        </div>

        {/* ── TESTIMONIALS GRID ── */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-291">
          {testimonials.map(t => <div key={t.initials} className="flex items-start gap-2 bg-white/80 border border-purple-400/30 rounded-lg p-3 shadow-sm" data-id="element-292">
              <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-black text-purple-700" style={{
            background: 'linear-gradient(135deg, rgba(124,58,237,0.12) 0%, rgba(168,85,247,0.12) 100%)'
          }} data-id="element-293">
                {t.initials}
              </div>
              <div data-id="element-294">
                <div className="mb-1 text-[10px] text-purple-600" data-id="element-295">
                  ⭐⭐⭐⭐⭐
                </div>
                <p className="text-xs font-medium text-gray-900 m-0" data-id="element-296">
                  {t.quote}
                </p>
                <p className="text-[10px] text-gray-500 mt-1 mb-0" data-id="element-297">
                  {t.author}
                </p>
              </div>
            </div>)}
        </div>

      </div>
    </section>;
}